import { convertPriceAndRoundUp } from 'search/utils/convertPriceAndRound';
import { DEFAULT_CURRENCY_CODE } from 'shared/enums/SitePreferences';
import { FILTER_ENUMS } from 'search/enums/constants';
import { getRegionPricingVariationsPriority } from 'search/utils/getRegionPricingVariationsPriority';
import { IConstructorResult } from 'shared/types/ConstructorResult';
import { ParsedUrlQuery } from 'querystring';
import { RegionPricing } from 'search/types/RegionPricing';

interface IGetLowestPriceCentsParams {
  selectedCurrencyCode: string;
  currencyRates: { [key: string]: number };
  result: IConstructorResult;
  globalPricingId: string;
  query: ParsedUrlQuery;
}

export const getLowestPriceCents = ({
  selectedCurrencyCode,
  result,
  currencyRates,
  globalPricingId,
  query,
}: IGetLowestPriceCentsParams) => {
  const { data, variations_map: variationsMap } = result;

  let {
    instant_ship_lowest_price_cents: instantShipLowestPriceCents,
    lowest_price_cents: lowestPriceCents,
    retail_price_cents: retailPrice,
  } = data;

  const regionVariationsPricing: RegionPricing = getRegionPricingVariationsPriority(variationsMap);
  let regionPricingLowestPriceCents = regionVariationsPricing?.minRegionalPrice;
  let regionPricingInstantShipLowestPriceCents =
    regionVariationsPricing?.minRegionalInstantShipPrice;

  // Do currency calculation based on currencyRates from Constructor if selected currency is not USD
  if (selectedCurrencyCode !== DEFAULT_CURRENCY_CODE) {
    const priceConversionRate = currencyRates?.[selectedCurrencyCode];

    if (priceConversionRate) {
      lowestPriceCents = convertPriceAndRoundUp(lowestPriceCents, priceConversionRate);
      instantShipLowestPriceCents = convertPriceAndRoundUp(
        instantShipLowestPriceCents,
        priceConversionRate,
      );
      retailPrice = convertPriceAndRoundUp(retailPrice, priceConversionRate);

      if (globalPricingId) {
        regionPricingLowestPriceCents = convertPriceAndRoundUp(
          regionPricingLowestPriceCents,
          priceConversionRate,
        );
        regionPricingInstantShipLowestPriceCents = convertPriceAndRoundUp(
          regionPricingInstantShipLowestPriceCents,
          priceConversionRate,
        );
      }
    }
  }

  const isInstantShipFilterApplied = Object.keys(query).includes(FILTER_ENUMS.INSTANT_SHIP);
  const convertedLowestPriceCents = globalPricingId
    ? regionPricingLowestPriceCents
    : lowestPriceCents;
  const convertedInstantShipLowestPriceCents = globalPricingId
    ? regionPricingInstantShipLowestPriceCents
    : instantShipLowestPriceCents;
  const price = isInstantShipFilterApplied
    ? convertedInstantShipLowestPriceCents
    : convertedLowestPriceCents;

  return { price, retailPrice };
};
